import React, { useState } from 'react';
import { AssignmentType } from '../../../../model';
import { Variable } from '.';
import { Accordion, SvgImage, BusyContainer, IconButton} from '../../../../components';
import { configuratorActions, getLanguages, translate } from '../../../../services';
import { addonsInfoIcon, newExpandButton, resetIcon,infoIcon } from '../../../../../style/images';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { hasAnyAssignableValues, translateProperty } from '../../../../util';
import { PropTypes } from 'prop-types';
var flag=false;

import Tooltip from '@mui/material/Tooltip';
import { createStyles, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(() =>
  createStyles({
    tooltip: {
      background: "#fff !important",
      color: "#000 !important",
      // border: "1px solid #D9D9D9 !important",
      // borderRadius: '4px !important',
      fontFamily: 'ABBvoice Regular !important',
      boxShadow: "0px 20px 32px 0px rgba(102, 102, 102, 0.32), 0px 2px 8px 0px rgba(15, 15, 15, 0.12), 0px 0px 1px 0px rgba(15, 15, 15, 0.16)",
    },
    arrow: {
      fontSize: 16,
      width: 17,
      "&::before": {
        border: "1px solid #D9D9D9 !important",
        backgroundColor: "#fff !important",
        boxSizing: "border-box",
      }
    }
  })
);

const LightTooltip = (props) => {
  const classes = useStyles();

  return (
    <Tooltip
      {...props}
      arrow
      classes={{
        tooltip: classes.tooltip,
        arrow: classes.arrow,
      }}
    ></Tooltip>
  );
};

export const UiGroup = ( { group, assignValue, removeValue, reset, hasChildren, children, depth = 0, configuration, checkFeasibility, fromFeasibility, fromFeasibilityChild,placeholder_value, isAccordionRequired = true} ) => {
  const language = getLanguages()[0];
  const fromItct = fromFeasibility ? 'ITCT' : '';
  const isFeasibility = fromFeasibility || fromFeasibilityChild;
  const [isExpanded, setIsExpanded] = useState(true)

  const screenSize = useSelector(state=>state.screenSize)
  let resetVariable =  group.variables.map( ( variable, key ) => {
    // if it shouldn't be visible or
    // if it doesn't have an assignable value that is different from not applicable then return null
    if(variable.fullyQualifiedName==="Selector.GrpCore1.varCore1Accuracyclass"){
      if(variable.assignedValue?.name?.includes("P")){flag=true}
      else{flag=false}
    }
    if(variable.fullyQualifiedName==="Selector.GrpCore1.varCore1Fs" && flag==true){
      return null;
    }
    if ( !variable || !variable.show || !variable.values.any( val => AssignmentType.isAvailable( val ) && val.title !== 'Not applicable' ) ) {
      return null;
    }
    return variable
  }
  ).any(variable=>variable && variable.assignedValue!==null);
  let variableComponents = group.variables.map( ( variable, key ) => {
    // if it shouldn't be visible or
    // if it doesn't have an assignable value that is different from not applicable then return null
    if(variable.fullyQualifiedName==="Selector.GrpCore1.varCore1Accuracyclass"){
      if(variable.assignedValue?.name?.includes("P")){flag=true}
      else{flag=false}
    }
    if(variable.fullyQualifiedName==="Selector.GrpCore1.varCore1Fs" && flag==true){
      return null;
    }
    if ( !variable || !variable.show || !variable.values.any( val => AssignmentType.isAvailable( val ) && val.title !== 'Not applicable' ) ) {
      return null;
    }

    let selectedValue = variable.assignedValue 
    ? variable.assignedValue.name 
    : variable.showAs === 'Calculated' 
      ? variable.properties.CalculatedValue 
      : variable.properties.DefaultValue;  

        return isAccordionRequired ? <Variable 
        key={ variable.name + key + selectedValue + AssignmentType.createHashKey( variable.values ) + fromItct} 
        variable={ variable } 
        language={ language }
        selectedValue={ selectedValue } 
        variables={ group.variables }
        assignValue={ assignValue } 
        removeValue={ removeValue }
        configuration={ configuration }
        fromFeasibility = {isFeasibility}
        placeholder_value={placeholder_value}
        fromUiGroup
      />: <span className='row-container'>
        { <span style={(variable.properties.Required && !selectedValue) ?{width:"16px", height:"16px", fill:"#696969", cursor:"pointer"} : {display: 'none'}} ><LightTooltip key="svg-tooltip" title={'Select value in the dropdown to accessories.'} placement="right"><img src={addonsInfoIcon}></img></LightTooltip></span> }
        <Variable 
        key={ variable.name + key + selectedValue + AssignmentType.createHashKey( variable.values ) + fromItct} 
        variable={ variable } 
        language={ language }
        selectedValue={ selectedValue } 
        variables={ group.variables }
        assignValue={ assignValue } 
        removeValue={ removeValue }
        configuration={ configuration }
        fromFeasibility = {isFeasibility}
        placeholder_value={translate('Select...') }
        fromUiGroup
      />
      </span>;
  } );

  // header has a dynamic height
  const header = React.createElement( `h${3 + depth}`, null, [
    translateProperty( group.properties, group.title ),
    checkFeasibility && <IconButton
    key="icon-button"
    tooltip={ translate('Check Feasibility') }
    className={ "check-feasibility-button" }
    text={ translate('Check Feasibility') }
    onClick={checkFeasibility?.onClick}
    />,
    reset && <div> <SvgImage source={ resetIcon } className="reset-icon" onClick={ reset } key={ 2 } />
    {group.properties && group.properties.Info && group.properties.Info.substring( 0,4 ) === 'http' ? <a href={ group.properties.Info } target="blank" style={{maxHeight: "19px"}}> <InfoOutlinedIcon className='infoIcon-add-ons' /> </a> : null}
  </div>
  ] );

  const childrenUiGroups = hasChildren && children.filter( group => hasAnyAssignableValues( group ) ).filter( child => child.show ).map( ( child, key ) =>
    <UiGroup key={ child.title + key + AssignmentType.createHashKey( child.variables ) + fromItct} 
      configuration={ configuration }
      group={ child }
      depth={ depth + 1 } 
      hasChildren={ child.hasChildren }
      children={ child.children }
      assignValue={ assignValue } 
      removeValue={ removeValue }
      fromFeasibilityChild = {fromFeasibility}
      isAccordionRequired = {isAccordionRequired}
    /> ) 

    const handleExpand = ()=>{
      setIsExpanded(!isExpanded)
    }
  return isAccordionRequired ? <Accordion defaultExpanded>
    { header }
    <div style={fromFeasibility ? {display: "flex"}: {}}>
      <BusyContainer className={fromFeasibility ? "feasibility-selector" : ""} 
      // actions={ [configuratorActions.ASSIGN, configuratorActions.RESET, configuratorActions.REMOVE, configuratorActions.LOADED] }
      >
        { variableComponents }
      </BusyContainer>
      {fromFeasibility ? <div className='feasibility-selector'>{childrenUiGroups}</div> : <>{childrenUiGroups}</>}
    </div>
  </Accordion>
  : <div className={classNames('add-ons-container', `ui-depth-${depth}`)}>
    <span className='add-ons-heading-container'>
      <span className='add-ons-headings'>
      {screenSize.width>900&&<SvgImage source={ newExpandButton } className={classNames("expander-icon",{'expanded':isExpanded})} onClick={handleExpand}></SvgImage>}
        {translateProperty( group.properties, group.title )}</span>
      { resetVariable&&<span>{reset && (screenSize.width>900?<SvgImage source={ resetIcon } className="reset-icon" onClick={ reset } key={ 2 } />:
        <div className='reset-area' onClick={ reset }>
          {/* <span>{translate("Reset all")}</span> */}
          <SvgImage source={ resetIcon } className="reset-icon" key={ 2 } />
        </div>
      )}</span>}
      {group.properties && group.properties.Info && group.properties.Info.substring( 0,4 ) === 'http' ? <a href={ group.properties.Info } target="blank" style={{maxHeight: "19px"}} > <InfoOutlinedIcon className='infoIcon-add-ons' /> </a> : null}
      {screenSize.width<=900&&<SvgImage source={ newExpandButton } className={classNames("expander-icon",{'expanded':isExpanded})} onClick={handleExpand}></SvgImage>}
    </span>
    {isExpanded&&<div style={fromFeasibility ? {display: "flex"}: {height : '100%', width:"100%"}}>
      {variableComponents.length>0&&<BusyContainer className={fromFeasibility ? "feasibility-selector" : ""}
      //  actions={ [configuratorActions.ASSIGN, configuratorActions.RESET, configuratorActions.REMOVE, configuratorActions.LOADED] }
      >
        { variableComponents }
      </BusyContainer>}
      {fromFeasibility ? <div className='feasibility-selector'>{childrenUiGroups}</div> : <>{childrenUiGroups}</>}
    </div>}
  </div>
};

UiGroup.propTypes = {
  assignValue: PropTypes.func.isRequired, 
  children: PropTypes.arrayOf( PropTypes.object ), 
  depth: PropTypes.number,
  group: PropTypes.shape( {
    properties: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    variables: PropTypes.array.isRequired
  } ), 
  hasChildren: PropTypes.bool.isRequired, 
  removeValue: PropTypes.func.isRequired, 
  reset: PropTypes.func
};